import { render, staticRenderFns } from "./ikids_modal_icare_youth.vue?vue&type=template&id=7f2cfafe&"
import script from "./ikids_modal_icare_youth.vue?vue&type=script&lang=js&"
export * from "./ikids_modal_icare_youth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports